export default __webpack_public_path__ + "static/media/Inter-roman.var.b65534c5.woff2";